import { TOfferCategory } from '../types/offer';
import { plural } from '@cian/utils';
import { flat, suburban } from '../constants';

export function getSimilarLinkText(count: number, category?: TOfferCategory): string {
  const modifiedCount = count + 1;
  switch (category) {
    case 'newBuildingFlatSale':
      return `Ещё ${modifiedCount} ${plural(modifiedCount, flat)} в этом ЖК`;
    case 'cottageSale':
    case 'houseSale':
    case 'houseShareSale':
    case 'landSale':
    case 'townhouseSale':
      return `Ещё ${count} ${plural(count, suburban)} в этом КП`;
    default:
      return `Ещё ${modifiedCount} ${plural(modifiedCount, flat)} в этом доме`;
  }
}
